import React, { useState } from 'react';
import {Button, Form} from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { loadFileRequests } from "../../services/action-creators"
import { chooseClean, chooseClient } from "../../services/action-creators"
import { TablePagination } from "@material-ui/core";
import { CSVLink } from "react-csv";
import AdminFileRequest from "./AdminFileRequest";
import { getDateTimeString, getSmallId, getCsvFileName, getCsvData } from "../../utils/helpers";


const AdminCleanHelpRequests = () => {
    const { fileRequests, fileRequestsLoaded, fileRequestsLoading, failure } = useSelector((state) => state.file);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchSub, setSearchSub] = useState("");
    const { chosenId } = useSelector((state) => state.admin);
    const dispatch = useDispatch();
    const history = useHistory();

    const handleIdClick = (id) => () => {
        dispatch(chooseClient(id))
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleSearchChange = (event) => {
        setSearchSub(event.target.value);
    };

    if (failure && !fileRequestsLoaded) {
        setTimeout(() => dispatch(chooseClean(history)), 5000);
        // TODO: Show Error Modal
        return (<div> failure : {JSON.stringify(failure)}</div>)
    }

    if (!fileRequestsLoading && !fileRequestsLoaded) {
        dispatch(loadFileRequests());
        return (<div> loading ... </div>);
    }

    const countUsers = () => {
        return filterUsers().length;
    };

    const filterUsers = () => {
        // console.error('filter fileRequests', fileRequests);
        const result = Object.keys(fileRequests)
            .filter(
                key => searchSub === "" ||
                    (fileRequests[key].email.includes(searchSub)) ||
                    (key.includes(searchSub))

                // fileRequests[key].result === status
            );

        // console.error('res', result);
        return result;
    };

    if(!Object.keys(fileRequests).length) {
        return (<></>);
    }

    if (chosenId) {
        return <AdminFileRequest/>
    }

    return(
        <div className = "clients_content_section">
            <div className="clients_menu">

                <Form.Control className="table_clients_search" type="search" onChange={handleSearchChange} placeholder=""/>

                <CSVLink data={ getCsvData(filterUsers(), fileRequests) } filename={ getCsvFileName('clients', searchSub) }>
                    <Button variant="success" >Export to CSV</Button>
                </CSVLink>
            </div>
            <div className="line"></div>

            <div className="table_clients">
                <TablePagination
                    component="div"
                    count={countUsers()}
                    page={Number(page)}
                    onPageChange={handlePageChange}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <div className="t_row t_header">
                    <div className="tc_center tc_id">User ID</div>
                    <div className="tc_email">Email</div>
                    <div className="tc_checks">Checks</div>
                    <div className="tc_center tc_payments">Payments</div>
                    <div className="tc_center tc_date">Last Signin Date</div>
                    <div className="tc_center tc_date">Registration Date</div>
                    <div className="tc_center tc_block">Block Acc</div>
                    <div className="tc_center tc_ip">IP</div>
                </div>



                {filterUsers()
                    .filter(
                        (el, i) =>
                            i < rowsPerPage * ( Number(page) + 1 ) &&
                            i > ( Number(page) * rowsPerPage - 1 )
                    )
                    .map((res, i) => {
                        // console.error('user', i, res);
                        return res;
                    })
                    .map((key, index) => (
                        <div className="t_row" key={key}>
                            <div className="tc_click tc_center tc_id" onClick={handleIdClick(fileRequests[key]._id)}>
                                {getSmallId(fileRequests[key]._id)}</div>
                            <div className="tc_email">{fileRequests[key].email}</div>
                            <div className="tc_checks">{fileRequests[key].credits}</div>
                            <div className="tc_center tc_payments">{fileRequests[key].credits}</div>
                            <div className="tc_center tc_date">{getDateTimeString(fileRequests[key].lastSignInDate)}</div>
                            <div className="tc_center tc_date">{getDateTimeString(fileRequests[key].createdAt)}</div>
                            <div className="tc_center tc_block">
                                <img src={fileRequests[key].blockAccount ? "images/clients/circle-cancel.svg" : "images/clients/circle-ok.svg"} alt=""/>
                            </div>
                            <div className="tc_center tc_ip">{fileRequests[key].registrationIP}</div>
                        </div>
                    ))}
            </div>
        </div>
    )
};

export default AdminCleanHelpRequests;